var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    container: {
        display: 'inline-flex',
        alignItems: 'center',
        border: '1px solid #0078d4',
        borderRadius: '4px',
        overflow: 'hidden',
        flex: '0 0 auto',
    },
    segment: {
        minWidth: '80px',
        height: '32px',
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 600,
        padding: '0 16px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        whiteSpace: 'nowrap',
    },
    segmentActive: {
        backgroundColor: '#0078d4',
        color: '#ffffff',
        cursor: 'default',
    },
    segmentInactive: {
        backgroundColor: '#ffffff',
        color: '#0078d4',
    },
    segmentDisabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
    },
};
export default styles;
//# sourceMappingURL=CalendarViewSwitcher.styles.js.map